import styled from "styled-components";
import { Flex } from "antd";

// ─── Scale Footer Container ────────────────────────────────────────────────────
// Needs styled.div — has border, padding, background (visual, not layout).

export const ScaleFooterContainerStyled = styled.div`
  flex-shrink: 0;
  padding: 10px 24px 14px;
  background: ${(p) => p.theme?.colors?.white ?? "#ffffff"};
  border-top: 1px solid ${(p) => p.theme?.colors?.border ?? "#D8DAE5"};
`;

export const ScaleHeadingStyled = styled.span`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

// ─── Scale Items Row ───────────────────────────────────────────────────────────
// Flex handles: display, flex-wrap, align-items, gap.
// styled adds only margin-top (not a Flex prop).

export const ScaleItemsRowStyled = styled(Flex)`
  margin-top: 6px;
`;

export const ScaleItemTextStyled = styled.span`
  font-size: 13px;
`;
